export default __webpack_public_path__ + "a16d18fce2f87aeb59db1ca820016f74.png";